import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppletPluginPricingsContainerModel } from "../../../../../models/aggregates/applet/applet-plugin-pricings-container.model";
import { BaseApiTemplateService, Core2Config } from "../shared";

@Injectable({
    providedIn: 'root',
})
export class AppletPluginPricingService extends BaseApiTemplateService<AppletPluginPricingsContainerModel>{
    constructor(http: HttpClient){
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'applet-plugin-pricings';
        this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + '/applet-plugin-pricings';
        this.httpClient = http;
    }
}